import { z } from 'zod';
import { ReferralStoredDocumentsSchema } from '../ReferralDocumentsSchema';

// Documents are OPTIONAL for L&G CI — Customer Support may attach a supporting
// document when creating the referral, but a referral is valid without one.
// The shape is the shared typed array (PPL-3549), with no requirement on top.
export const ReferralLandgCIDocumentsSchema = ReferralStoredDocumentsSchema;

export type ReferralLandgCIDocuments = z.infer<
  typeof ReferralLandgCIDocumentsSchema
>;
